import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Mom", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Partner", -1)
const _hoisted_4 = { key: 0 }

import {
    missedIncomeForRegulationPerDay,
    useLeaveStore,
    YearMonth,
    YearMonthIncome,
    yearMonthKey,
    YearMonthLeaveDays,
    YearMonthRegulations
} from '@/stores/leave'
import { computed } from 'vue'
import RowWithInfo from '@/components/RowWithInfo.vue'
import Money from '@/components/Money.vue'
import YearMonthRegulationInfo from '@/components/YearMonthRegulationInfo.vue'
import { formatMoney } from '@/helpers/formatMoney'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinancialMonthRow',
  props: {
    yearMonth: null,
    leaveDaysMom: null,
    leaveDaysPartner: null,
    regulationsMom: null,
    regulationsPartner: null,
    incomeMom: null,
    incomePartner: null
  },
  setup(__props: any) {

const props = __props as {
    yearMonth: YearMonth
    leaveDaysMom: YearMonthLeaveDays | null
    leaveDaysPartner: YearMonthLeaveDays | null
    regulationsMom: YearMonthRegulations | null
    regulationsPartner: YearMonthRegulations | null
    incomeMom: YearMonthIncome | null
    incomePartner: YearMonthIncome | null
};



const leaveStore = useLeaveStore()

function getTitle(yearMonth: YearMonth): string {
    const date = new Date(yearMonth.year, yearMonth.month, 1)
    return date.toLocaleString('default', {
        month: 'long',
        year: 'numeric'
    })
}

const key = computed(() => yearMonthKey(props.yearMonth.year, props.yearMonth.month))

function calculationSentence(
    mom: boolean,
    yearMonthRegulations: YearMonthRegulations,
    yearMonthIncome: YearMonthIncome,
): string | undefined {
    const regulations = yearMonthRegulations[key.value]
    if (!regulations) {
        return
    }

    const dailySalary = leaveStore.dailySalary(mom)
    if (!dailySalary) {
        return
    }

    const monthlySalary = leaveStore.normalMonthlyIncome(mom)
    if (!monthlySalary) {
        return
    }

    const parts: string[] = []

    Object.keys(regulations).forEach(regulationId => {
        const regulation = leaveStore.regulations.find(reg => reg.id === regulationId)
        const days = regulations[regulationId]
        const missedIncomePerDay = missedIncomeForRegulationPerDay(regulation!!, dailySalary)

        parts.push(days + ' × ' + formatMoney(missedIncomePerDay))
    })

    return formatMoney(monthlySalary) + ' − (' + parts.join(' + ') + ') = ' + formatMoney(yearMonthIncome[key.value])
}

const calculationMom = computed(() => {
    if (!props.regulationsMom || !props.incomeMom) {
        return
    }

    return calculationSentence(true, props.regulationsMom, props.incomeMom)
})

const calculationPartner = computed(() => {
    if (!props.regulationsPartner || !props.incomePartner) {
        return
    }

    return calculationSentence(false, props.regulationsPartner, props.incomePartner)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RowWithInfo, {
    title: getTitle(__props.yearMonth)
  }, {
    info: _withCtx(() => [
      (__props.leaveDaysMom && __props.incomeMom && __props.regulationsMom)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Taking a total of " + _toDisplayString(__props.leaveDaysMom[_unref(key)]) + " days of leave this month.", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.regulationsMom[_unref(key)]), (regulationId) => {
                return (_openBlock(), _createBlock(YearMonthRegulationInfo, {
                  month: __props.yearMonth.month,
                  year: __props.yearMonth.year,
                  regulationId: regulationId,
                  days: __props.regulationsMom!!,
                  mom: true
                }, null, 8, ["month", "year", "regulationId", "days"]))
              }), 256)),
              (__props.leaveDaysMom[_unref(key)] > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_2, _toDisplayString(_unref(calculationMom)), 1))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
      (__props.leaveDaysPartner && __props.incomePartner && __props.regulationsPartner)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_3,
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Taking a total of " + _toDisplayString(__props.leaveDaysPartner[_unref(key)]) + " days of leave this month.", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.regulationsPartner[_unref(key)]), (regulationId) => {
                return (_openBlock(), _createBlock(YearMonthRegulationInfo, {
                  month: __props.yearMonth.month,
                  year: __props.yearMonth.year,
                  regulationId: regulationId,
                  days: __props.regulationsPartner!!,
                  mom: false
                }, null, 8, ["month", "year", "regulationId", "days"]))
              }), 256)),
              (__props.leaveDaysPartner[_unref(key)] > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_unref(calculationPartner)), 1))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("td", null, [
        (__props.incomeMom)
          ? (_openBlock(), _createBlock(Money, {
              key: 0,
              value: __props.incomeMom[_unref(key)]
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", null, [
        (__props.incomePartner)
          ? (_openBlock(), _createBlock(Money, {
              key: 0,
              value: __props.incomePartner[_unref(key)]
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", null, [
        (__props.incomePartner && __props.incomeMom)
          ? (_openBlock(), _createBlock(Money, {
              key: 0,
              value: __props.incomePartner[_unref(key)] + __props.incomeMom[_unref(key)]
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})